import { useEffect } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { useT, useLang } from "@/i18n";
import DATA from "@/data/lamellare.json";

const useFaqSchema = (faq) => {
  useEffect(() => {
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.dataset.faq = "lamellare";
    el.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faq.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })),
    });
    document.head.appendChild(el);
    return () => { el.remove(); };
  }, [faq]);
};

export const LamellareFaq = ({ dataKey = "faq", titleKey = "faq.h", title = "Domande frequenti sul legno lamellare" }) => {
  const t = useT();
  const { lang } = useLang();
  const faq = (DATA[lang] ?? DATA.it)[dataKey];
  useFaqSchema(faq);
  return (
    <section id="faq" className="bg-[#F7F5F0] px-5 py-24 text-[#121110] sm:px-8 lg:py-32" data-testid="faq-section">
      <div className="mx-auto grid max-w-[1500px] gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#9A5326]">FAQ</p>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight sm:text-4xl">{t(titleKey, title)}</h2>
        </div>
        <Accordion type="single" collapsible className="lg:col-span-8 [&_[role=region][data-state=closed]]:hidden" data-testid="faq-list">
          {faq.map(([q, a], i) => (
            <AccordionItem key={q} value={`q${i}`} className="border-[#121110]/15">
              <AccordionTrigger className="py-5 text-left font-display text-lg font-semibold hover:no-underline" data-testid={`faq-q-${i}`}>{q}</AccordionTrigger>
              <AccordionContent forceMount className="pb-5 text-base leading-relaxed text-[#3D3833]" data-testid={`faq-a-${i}`}>{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
